// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1_RdU","cls2":"SimplePaperPodcast-cls2_r8R SimplePaperPodcast-cls1_RdU"};